/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/idioma";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/idioma/idioma",
            controller: 'IdiomaAdminController',
            controllerForm: 'IdiomaFormAdminController',
            translateBase: "admin.idioma."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {});

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)

    }
})();
